module.exports = __webpack_public_path__ + "static/img/05.325d027.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/loacker/05.jpg
// module id = 420
// module chunks = 1